
import { useAxios } from '../../../../../../../../hooks/useAxios';
import { InscripcionAdapters, InscripcionesAdapters } from '../adapters/inscripciones.adapter';

const InscripcionesServices = {

    GET: function (idevento: string) {

        return useAxios({ method: 'get', url: `/inscripciones/inscripciones`, type: 'json', adapters: InscripcionesAdapters.GET })
    },

    GET_EXCEL: function () {

        return useAxios({ method: 'get', url: `/inscripciones/inscripciones`, type: 'blob', adapters: InscripcionesAdapters.GET_EXCEL })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/inscripciones/inscripcion-admin`, type: 'json', adapters: InscripcionesAdapters.POST })
    },

    PATCH: function (ideventotarifa: string) {

        return useAxios({ method: 'patch', url: `/inscripciones/inscripcion-admin/${ideventotarifa}`, type: 'json', adapters: InscripcionesAdapters.PATCH })
    },

    DELETE: function (ideventotarifa: string) {

        return useAxios({ method: 'delete', url: `/inscripciones/inscripcion-admin/${ideventotarifa}`, type: 'json', adapters: InscripcionesAdapters.DELETE })
    },

    POST_ENVIAR_EMAILS_MASIVOS: function () {

        return useAxios({ method: 'post', url: `/inscripciones/inscripciones-admin/notificaciones/enviar`, type: 'json', adapters: InscripcionesAdapters.POST_ENVIAR_EMAILS_MASIVOS })
    },

    PATCH_ACTUALIZAR_CERTIFICADO: function () {

        return useAxios({ method: 'patch', url: `/inscripciones/plantillas-certificados/inscripciones-status/update`, type: 'json', adapters: InscripcionesAdapters.PATCH_ACTUALIZAR_CERTIFICADO })
    }
}

const InscripcionServices = {

    GET: function () {

        return useAxios({ method: 'get', url: `/inscripciones/inscripciones`, type: 'json', adapters: InscripcionAdapters.GET })
    },
    
    POST: function () {

        return useAxios({ method: 'post', url: `/inscripciones/inscripcion-admin`, type: 'json', adapters: InscripcionAdapters.POST })
    },

    PATCH: function (idinscripcion: any) {

        return useAxios({ method: 'patch', url: `/inscripciones/inscripcion-admin/${idinscripcion}`, type: 'json', adapters: InscripcionAdapters.PATCH })
    },

    DELETE: function (idinscripcion: string) {

        return useAxios({ method: 'delete', url: `/inscripciones/inscripcion-admin/${idinscripcion}`, type: 'json', adapters: InscripcionesAdapters.DELETE })
    }
}

export {
    InscripcionesServices,
    InscripcionServices,
}